import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'overview',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import('./views/Overview.vue')
		},
		{
			path: '/callback/:access_token',
			name: 'callback',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import('./views/Callback.vue')
		},
		{
			path: '/:id',
			name: 'vacation',
			component: () => import('./views/Vacation.vue')
		},
		{
			path: '/:id/edit',
			name: 'editvacation',
			component: () => import('./views/Vacationedit.vue')
		}
	]
})
